import React from 'react';
import { observer } from 'mobx-react-lite';
import { KeyboardAvoidingView, Platform, View } from 'react-native';
import { styled } from 'dripsy';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { globalStyles } from '@styles';
import { useNavOptionsSet } from '@hooks';
import { IS_IOS } from '@utils';
import { useMessaging } from './hooks/useMessaging';
import { MessagingFooter } from './components/MessagingFooter';
import { MessagingHeader } from './components/MessagingHeader';
import { MessagesList } from './components/MessagesList';
import { ScreenLoader } from '@components';

interface IContainerStyleProps {
  bottomInset: number;
}

const Container = styled(View)((props: IContainerStyleProps) => ({
  flex: 1,
  bg: '$background0',
  pb: props.bottomInset,
}));

const MessagingFooterContainer = styled(View)({
  py: '$5',
});

export const MessagingScreen = observer(() => {
  const insets = useSafeAreaInsets();
  const { conversation, fetchMoreMessages } = useMessaging();

  useNavOptionsSet(
    Platform.select({
      native: {
        headerShown: true,
        header: () => <MessagingHeader />,
      },
      default: {},
    }),
  );

  if (!conversation) {
    return <ScreenLoader />;
  }

  return (
    <Container bottomInset={insets.bottom}>
      <KeyboardAvoidingView
        behavior={IS_IOS ? 'padding' : 'height'}
        keyboardVerticalOffset={64 + insets.top}
        style={globalStyles.wrapper}
      >
        <MessagesList
          list={conversation.messages}
          fetchMore={fetchMoreMessages}
        />
        <MessagingFooterContainer>
          <MessagingFooter conversationId={conversation.id} />
        </MessagingFooterContainer>
      </KeyboardAvoidingView>
    </Container>
  );
});
